import {GraphNodeModel} from './graph-node.model';
import {GraphLinkModel} from './graph-link.model';
import {Type} from 'class-transformer';
import {BaseIdModel} from 'common-shared';

export class GraphModel extends BaseIdModel {
  @Type(() => GraphNodeModel)
  Nodes: GraphNodeModel[];
  @Type(() => GraphLinkModel)
  Links: GraphLinkModel[];
}
